import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";

const ddClientToken = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN!;
const ddApplicationId = process.env.NEXT_PUBLIC_DD_APPLICATION_ID!;

datadogRum.init({
    applicationId: ddApplicationId,
    clientToken: ddClientToken,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: "datadoghq.eu",
    service: "frontend",
    env: process.env.NEXT_PUBLIC_DD_ENV,
    version: process.env.NEXT_PUBLIC_DD_VERSION,
    sessionSampleRate: 10,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "allow",
    allowedTracingUrls: [
        /http:\/\/localhost:3000.*/,
        /https:\/\/.*vercel\.app/,
    ],
});

datadogLogs.init({
    clientToken: ddClientToken,
    site: "datadoghq.eu",
    service: "frontend",
    env: process.env.NEXT_PUBLIC_DD_ENV,
    version: process.env.NEXT_PUBLIC_DD_VERSION,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    forwardConsoleLogs: "all",
});
